import styled from 'styled-components';

type ButtonWrapperProps = {
  size: number;
  color: string;
  backgroundColor: string;
  width: number;
  fontWeight?: number;
  textAlign?: string;
  borderRadius?: number;
  padding?: string;
  borderColor?: string;
  height?: number;
  justifyContent?: string;
  display?: string;
};

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  font-size: ${(props) => props.size}px;
  width: ${(props) => props.width}%;
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundColor};
  display: ${(props) => props.display ?? 'flex'};
  text-align: ${(props) => props.textAlign ?? 'center'};
  border-radius: ${(props) => props.borderRadius ?? 3}px;
  padding: ${(props) => props.padding ?? '7px'};
  font-weight: ${(props) => props.fontWeight ?? 'normal'};
  border-color: ${(props) => props.borderColor};
  height: ${(props) => props.height}%;
  ${(props) => (props.justifyContent ? `justify-content: ${props.justifyContent}` : '')}
`;
